export const FETCH_DEPARTMENTS_TYPE = 'FETCH_GREENHOUSE_DEPARTMENTS';
export const FETCH_DEPARTMENTS_PENDING = `${FETCH_DEPARTMENTS_TYPE}_PENDING`;
export const FETCH_DEPARTMENTS_FULFILLED = `${FETCH_DEPARTMENTS_TYPE}_FULFILLED`;
export const FETCH_DEPARTMENTS_REJECTED = `${FETCH_DEPARTMENTS_TYPE}_REJECTED`;

export const FETCH_OFFICES_TYPE = 'FETCH_GREENHOUSE_OFFICES';
export const FETCH_OFFICES_PENDING = `${FETCH_OFFICES_TYPE}_PENDING`;
export const FETCH_OFFICES_FULFILLED = `${FETCH_OFFICES_TYPE}_FULFILLED`;
export const FETCH_OFFICES_REJECTED = `${FETCH_OFFICES_TYPE}_REJECTED`;

export const FETCH_JOBS_TYPE = 'FETCH_GREENHOUSE_JOBS';
export const FETCH_JOBS_PENDING = `${FETCH_JOBS_TYPE}_PENDING`;
export const FETCH_JOBS_FULFILLED = `${FETCH_JOBS_TYPE}_FULFILLED`;
export const FETCH_JOBS_REJECTED = `${FETCH_JOBS_TYPE}_REJECTED`;

export const DEPARTMENT_FILTER_CHANGED = 'DEPARTMENT_FILTER_CHANGED';
export const OFFICE_FILTER_CHANGED = 'OFFICE_FILTER_CHANGED';

export const fetchDepartmentsActionCreator = promise => ({
  type: FETCH_DEPARTMENTS_TYPE,
  payload: promise,
});

export const fetchOfficesActionCreator = promise => ({
  type: FETCH_OFFICES_TYPE,
  payload: promise,
});

export const fetchJobsActionCreator = promise => ({
  type: FETCH_JOBS_TYPE,
  payload: promise,
});

export const departmentFilterChangedCreator = departmentId => ({
  type: DEPARTMENT_FILTER_CHANGED,
  payload: { departmentId: Number(departmentId) || 0 },
});

export const officeFilterChangedCreator = officeId => ({
  type: OFFICE_FILTER_CHANGED,
  payload: { officeId: Number(officeId) || 0 },
});
